import styled from 'styled-components'
import { Image } from 'src/components/Ant'

export const Div = styled.div`
  align-content: center;
  height: 90vh;
  text-align: center;
  width: 100vw;
`

export const Img = styled.img`
  margin-top: 1rem;
  width: 200px;
`

export const Logo = styled(Image)`
  max-width: 100%;
  width: 25rem;
`
